import React, { Fragment, useState, useEffect, useMemo, useRef } from "react";
import {
    Box,
    Button,
    Grid,
    Paper,
    Stepper,
    Step,
    StepLabel,
    Typography,
    TextField,
    Divider,
    Link,
} from "@mui/material";
import ReactDOM from "react-dom";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import Client from "../components/Client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { DesktopDateTimePicker, DatePicker } from "@mui/x-date-pickers";
import DateTimeTentativePickerComponent from "../components/DateTimeTentativePickerComponent";
import DateRange from "../PatientRegistration/components/DateRange";
import { InputAdornment } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import PromptDialog from "../components/CustomComponents/PromptDialog";
import DefaultButton from "../components/CustomComponents/DefaultButton";
import ReCaptchaComponent from "./components/Recaptcha";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import toastr from "toastr";
import io from "socket.io-client";

export default function Register() {
    const [otp, setOtp] = useState("");
    const [crewId, setCrewID] = useState(null);
    const [birthDate, setBirthDate] = useState(null);
    const [firstName, setFirstName] = useState(null);
    const [middleName, setMiddleName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [suffix, setSuffix] = useState(null);
    const [gender, setGender] = useState(null);
    const [nationality, setNationality] = useState(null);
    const [nationalityOptions, setNationalityOptions] = useState([]);
    const [maritalStatus, setMaritalStatus] = useState(null);
    const [emailAddress, setEmailAddress] = useState(null);
    const [emailAddressConfirmation, setEmailAddressConfirmation] =
        useState(null);
    const [contactNumber, setContactNumber] = useState(null);
    const [position, setPosition] = useState(null);
    const [province, setProvince] = useState(null);
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [city, setCity] = useState(null);
    const [cityOptions, setCityOptions] = useState([]);
    const [street, setStreet] = useState(null);
    const [barangay, setBarangay] = useState(null);
    const [barangayOptions, setBarangayOptions] = useState([]);
    const [barangay_loading, setBarangayLoading] = useState(false);
    const [zipCode, setZipCode] = useState(null);
    const [repatDate, setRepatDate] = useState(dayjs());
    const [allDay, setAllDay] = useState("no");
    const [formErrors, setFormError] = useState({});
    const [province_loading, setProvinceLoading] = useState(false);
    const [city_loading, setCityLoading] = useState(false);
    const [btn_loading, setBtnLoading] = useState(false);
    const [send_otp_btn_disabled, setSendOtpBtnDisabled] = useState(false);
    const [send_otp_btn_loading, setSendOtpBtnLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({});
    const [isVerified, setIsVerified] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [showErrorModal, setErrorModal] = useState(false);
    const client = Client();
    const [error, setError] = useState("");
    const steps = [
        "Welcome",
        "Personal Information",
        "Review & Submit",
        "Verification",
    ];

    // const SOCKET_URL = process.env.WEBSOCKETS_HOST;
    // const socket = io(SOCKET_URL, {
    //     transports: ["websocket"],
    // });
    const socketRef = useRef(null);
    useEffect(() => {
        // const SOCKET_URL = process.env.WEBSOCKETS_HOST;
        const SOCKET_URL = 'ws://localhost:3000';
        socketRef.current = io(SOCKET_URL, {
            transports: ["websocket"],
        });

        // Cleanup the socket connection when the component unmounts
        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
            }
        };
    }, []);

    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [timerVisible, setTimerVisible] = useState(false);
    const endDate = useMemo(() => {
        if (timerVisible) {
            return Date.now() + 120000; // 2 minutes in milliseconds
        }
        return null;
    }, [timerVisible]);

    //Set email after form submit
    const emailOTP = () => {
        setError(""); // Clear any previous errors
        client
            .post("/patient/register/email-otp", {
                email: emailAddress,
            })
            .then((response) => {
                console.log("emaiOTP response:", response.data);
                if (!response.data === 0) {
                    setError(
                        "Failed to send OTP. Please wait before trying again."
                    );
                    setSendOtpBtnDisabled(false);
                } else {
                    // setSendOtpBtnDisabled(false);
                    setOtpSent(true);
                    setTimerVisible(true);
                    toastr.success("OTP sent successfully.", null, {
                        positionClass: "toast-bottom-left",
                    });
                }
                setSendOtpBtnLoading(false);
            })
            .catch((error) => {
                console.error("Error sending OTP:", error);
                setError(
                    "An error occurred while sending the OTP. Please try again."
                );
                setSendOtpBtnLoading(false);
                setSendOtpBtnDisabled(false);
            });
    };
    //Verify otp
    const verifyOTP = () => {
        setError(""); // Clear any previous errors
        setBtnLoading(true); // Set loading to true when verification starts
        client
            .post("/patient/register/verify-otp", {
                email: emailAddress,
                otp: otp,
            })
            .then((response) => {
                if (response.data.message === "Verify Success") {
                    register();
                    setOtpVerified(true);
                    setActiveStep((prevStep) => prevStep + 1);
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 3000);
                } else {
                    setError(response.data.message);
                }
            })
            .catch((err) => {
                const errorMessage =
                    err.response?.data?.errors?.otp ||
                    "An unknown error occurred.";
                setError(errorMessage);
                console.log(errorMessage);
            })
            .finally(() => {
                setBtnLoading(false);
            });
    };
    //Resend OTP
    const resendOTP = () => {
        setError(""); // Clear any previous errors before resending
        client
            .post("/patient/register/resend-otp", {
                email: emailAddress,
            })
            .then((response) => {
                console.log(response.data);
                if (!response.data.success) {
                    setError(
                        "Failed to resend OTP. Please wait before trying again."
                    );
                    setSendOtpBtnDisabled(false);
                } else {
                    toastr.success("OTP successfully resent.", null, {
                        positionClass: "toast-bottom-left",
                    });
                    setTimerVisible(true);
                }
                setSendOtpBtnLoading(false);
            })
            .catch((error) => {
                console.error("Error resending OTP:", error);
                setError(
                    "An error occurred while resending the OTP. Please try again."
                );
                setSendOtpBtnLoading(false);
                setSendOtpBtnDisabled(false);
            });
    };
    // for otp send
    const handleBtnClick = () => {
        if (otpSent) {
            setSendOtpBtnDisabled(true);
            setSendOtpBtnLoading(true);
            resendOTP();
        } else {
            setSendOtpBtnDisabled(true);
            setSendOtpBtnLoading(true);
            emailOTP();
        }
    };

    //for otp btn timer
    function CountdownTimer({ endDate, onEndCallback }) {
        const [timeRemaining, setTimeRemaining] = useState(
            endDate - Date.now()
        );
        useEffect(() => {
            let timer;
            if (timeRemaining > 0) {
                timer = setInterval(() => {
                    setTimeRemaining(endDate - Date.now());
                }, 1000);
            }

            return () => {
                if (timer) {
                    clearInterval(timer);
                }
            };
        }, [timeRemaining, endDate]);

        const minutes = Math.floor(timeRemaining / 60000);
        const seconds = Math.floor((timeRemaining % 60000) / 1000);

        if (timeRemaining <= 0) {
            onEndCallback && onEndCallback();
        }

        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: "5px",
                }}
            >
                {`${String(minutes).padStart(2, "0")}:${String(
                    seconds
                ).padStart(2, "0")}`}
            </div>
        );
    }

    const handleTimerEnd = () => {
        setTimerVisible(false);
        setSendOtpBtnDisabled(false);
    };

    // only enable finish button when otp is verified
    useEffect(() => {
        console.log("otpVerifie:", otpVerified);
        if (otpVerified) {
            toastr.success("Verification success.", null, {
                positionClass: "toast-bottom-left",
            });
        }
    }, [otpVerified]);

    //Set options for province
    useEffect(() => {
        setProvinceLoading(true);
        client.post("/patient/register/getProvinces").then((response) => {
            setProvinceOptions(response.data);
            setProvinceLoading(false);
        });
    }, []);

    //Set options for city after setting province
    useEffect(() => {
        if (province != null) {
            setCityLoading(true);
            client
                .post("/patient/register/getCity", {
                    id: province.id,
                })
                .then((response) => {
                    setCityOptions(response.data);
                    setCityLoading(false);
                    console.log(cityOptions);
                });
        } else {
            setCityOptions([]);
            setCity(null);
        }
    }, [province]);

    //Set options for nationality
    useEffect(() => {
        client.post("/patient/register/getNationalities")
        .then((response) => {
            setNationalityOptions(response.data);
            console.log(nationalityOptions);
        });
    }, []);

    //set options for barangay after setting city
    useEffect(() => {
        if (city != null) {
            setBarangayLoading(true);
            client
                .post("/patient/register/getBarangay", {
                    id: city.id,
                })
                .then((response) => {
                    setBarangayOptions(response.data);
                    setBarangayLoading(false);
                    console.log(barangayOptions);
                });
        }
    }, [city]);

    const genderSelection = [{ label: "Male" }, { label: "Female" }];

    const maritalSelection = [
        { label: "Single" },
        { label: "Married" },
        { label: "Divorced" },
        { label: "Separated" },
        { label: "Widowed" },
    ];

    //Send request for field values verification
    const handleSave = () => {
        setFormError({});
        setBtnLoading(true);
        const savedData = {
            crewId,
            birthdate: birthDate ? birthDate.format("YYYY-MM-DD") : null,
            firstName,
            middleName,
            lastName,
            suffix,
            gender: gender?.label,
            nationality: nationality?.options,
            maritalstatus: maritalStatus?.label,
            emailAddress,
            emailAddressConfirmation,
            contactNumber,
            position,
            province: province?.description,
            city: city?.description,
            street,
            barangay: barangay?.description,
            zipCode,
            repatDate: repatDate? repatDate.format("YYYY-MM-DD") : null,
        };
        client
            .post("/patient/register/request-verify", savedData)
            .then((response) => {
                console.log("ok");
                setBtnLoading(false);
                setFormData(savedData);
                setActiveStep((prevStep) => prevStep + 1);
            })
            .catch((err) => {
                console.log("this is false");
                console.log("Errors", err.response.data.errors);
                setFormError(err.response.data.errors);
                console.log("formErrors", formErrors);
                setBtnLoading(false);
            });
    };

    //Send request for temporary registration of patient
    const register = () => {
        client
            .post("/patient/register-patient", {
                crew_id: crewId,
                position: position,
                repat_date: repatDate.format("YYYY-MM-DD"),
                first_name: firstName,
                middle_name: middleName,
                last_name: lastName,
                suffix: suffix,
                birthdate: birthDate.format("YYYY-MM-DD"),
                gender: gender.label,
                nationality: nationality?.options,
                marital_status: maritalStatus.label,
                email: emailAddress,
                contact_info: contactNumber,
                province: province.description,
                city: city.description,
                street: street,
                barangay: barangay.description,
                zip_code: zipCode,
            })
            .then((response) => {
                if (response.data) {
                    socketRef.current.emit("register", {
                        new_patient: response.data,
                    });
                    console.log("emitted");
                    // setTimeout(() => {
                    //     window.location.href = "/";
                    // }, 10000);
                } else {
                    return false;
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    console.log(activeStep);

    //Set form to next step
    const handleNext = () => {
        console.log("isVerified", isVerified);
        if (activeStep === 0) {
            setActiveStep((prevStep) => prevStep + 1);
        } else if (activeStep === 1) {
            handleSave();
        } else if (activeStep === 2) {
            if (!isVerified) {
                setErrorMessage("Please verify that you are not a robot.");
                return;
            }
            setErrorMessage("");
            // emailOTP();
            setActiveStep((prevStep) => prevStep + 1);
        } else if (activeStep === 3) {
            verifyOTP();
        } else {
            setActiveStep((prevStep) => prevStep + 1);
        }
    };

    //Set all Field Values to null when set back to first step
    const handleBack = () => {
        setActiveStep((prevActiveStep) => {
            const newStep = prevActiveStep - 1;
            if (newStep === 0) {
                setFormError({});
                setCrewID(null);
                setIsVerified(false);
                setPosition(null);
                setRepatDate(dayjs());
                setFirstName(null);
                setMiddleName(null);
                setLastName(null);
                setSuffix(null);
                setBirthDate(null);
                setGender(null);
                setNationality(null);
                setMaritalStatus(null);
                setProvince(null);
                setCity(null);
                setStreet(null);
                setBarangay(null);
                setZipCode(null);
                setEmailAddress(null);
                setEmailAddressConfirmation(null);
                setContactNumber(null);
            }
            return newStep;
        });
    };

    //Captcha Verification
    const handleVerification = (verified) => {
        setIsVerified(verified);
        if (!verified) {
            setErrorMessage("Please verify that you are not a robot."); // Set error message if captcha fails
        } else {
            setErrorMessage("");
        }
    };

    const renderStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <>
                        <Box
                            sx={{
                                borderLeft: "4px solid red",
                                paddingLeft: "16px",
                                paddingBottom: "10px",
                            }}
                        >
                            <Box sx={{ marginBottom: "0.5rem" }}>
                                <Typography
                                    variant="body"
                                    style={{
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                        color: "red",
                                    }}
                                >
                                    Reminder:
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: "0.5rem" }}>
                                <Typography
                                    variant="body"
                                    style={{ fontSize: "0.9rem" }}
                                >
                                    Patients are encouraged to use Google or
                                    Yahoo email accounts in registration to
                                    avoid any technical incompatibilities.
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: "0.5rem" }}>
                                <Typography
                                    variant="body"
                                    style={{ fontSize: "0.9rem" }}
                                >
                                    Patients are also reminded that the email
                                    account used for the registration must be
                                    valid, active, and accessible as the
                                    registration confirmation will be sent to
                                    that email account.
                                </Typography>
                            </Box>
                        </Box>
                    </>
                );
            case 1:
                return (
                    <Box>
                        <Grid container direction="column" spacing={3.5}>
                            {/* 1st row : Crew Information & Position & Date of Repat  */}
                            <Grid item sx={{ paddingTop: "15px !important" }}>
                                <Typography variant="h5"> Crew Info</Typography>
                            </Grid>
                            <Divider variant="middle" />
                            <Grid item sx={{ paddingTop: "10px !important" }}>
                                <Grid container direction="row" spacing={3}>
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="crew-id"
                                            size="small"
                                            label={
                                                <span>
                                                    Crew Member ID
                                                </span>
                                            }
                                            fullWidth
                                            value={crewId}
                                            onChange={(event) => {
                                                setCrewID(event.target.value);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    crewId: null,
                                                }));
                                            }}
                                            inputProps={{
                                                type: "number",
                                                inputMode: "numeric",
                                                pattern: "[0-9]*",
                                                onKeyDown: (e) => {
                                                    if (
                                                        [
                                                            "e",
                                                            "E",
                                                            "+",
                                                            "-",
                                                            ".",
                                                        ].includes(e.key)
                                                    ) {
                                                        e.preventDefault();
                                                    }
                                                },
                                                style: {
                                                    appearance: "none",
                                                    WebkitAppearance: "none",
                                                },
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                                // Additional sx to hide spinners
                                                '& input[type="number"]::-webkit-inner-spin-button':
                                                    {
                                                        display: "none",
                                                    },
                                                '& input[type="number"]::-webkit-outer-spin-button':
                                                    {
                                                        display: "none",
                                                    },
                                            }}
                                            error={!!formErrors.crewId}
                                            helperText={formErrors.crewId}
                                        />
                                    </Grid>
                                    {/* Position*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="position-id"
                                            size="small"
                                            label={
                                                <span>
                                                    Position
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            fullWidth
                                            value={position}
                                            onChange={(event, newValue) => {
                                                setPosition(event.target.value);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    position: null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={!!formErrors.position}
                                            helperText={formErrors.position}
                                        />
                                    </Grid>
                                    {/* Date of Repat */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                        >
                                            <DateRange
                                                label={
                                                    <span>
                                                        Date of Repatriation
                                                        <span
                                                            style={{
                                                                color: "red",
                                                            }}
                                                        >
                                                            *
                                                        </span>
                                                    </span>
                                                }
                                                allDay={repatDate}
                                                dateNeeded={repatDate}
                                                setDateNeeded={setRepatDate}
                                                error={formErrors}
                                                errorKey="repatDate"
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item sx={{ paddingTop: "15px !important" }}>
                                <Typography variant="h5">
                                    {" "}
                                    Personal Info
                                </Typography>
                            </Grid>
                            <Divider variant="middle" />
                            {/* 2nd row : Full Name*/}
                            <Grid item sx={{ paddingTop: "10px !important" }}>
                                <Grid container direction="row" spacing={3}>
                                    {/* First Name */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="first-name-id"
                                            size="small"
                                            label={
                                                <span>
                                                    First Name
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            fullWidth
                                            value={firstName}
                                            onChange={(event, newValue) => {
                                                setFirstName(
                                                    event.target.value
                                                );
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    firstName: null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={!!formErrors.firstName}
                                            helperText={formErrors.firstName}
                                        />
                                    </Grid>
                                    {/* Middle Name */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="middle-name-id"
                                            size="small"
                                            label="Middle Name"
                                            fullWidth
                                            value={middleName}
                                            onChange={(event, newValue) => {
                                                setMiddleName(
                                                    event.target.value
                                                );
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    middleName: null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={!!formErrors.middleName}
                                            helperText={formErrors.middleName}
                                        />
                                    </Grid>
                                    {/* Last Name */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="last-name-id"
                                            size="small"
                                            label={
                                                <span>
                                                    Last Name
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            fullWidth
                                            value={lastName}
                                            onChange={(event, newValue) => {
                                                setLastName(event.target.value);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    lastName: null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={!!formErrors.lastName}
                                            helperText={formErrors.lastName}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* 3rd row : Suffix Name, BirthDate, Gender */}
                            <Grid item>
                                <Grid
                                    container
                                    direction="row"
                                    spacing={3}
                                    // sx={{
                                    //     maxHeight: {
                                    //         xs: "none",
                                    //         sm: "61.03px",
                                    //         md: "61.03px",
                                    //     },
                                    // }}
                                >
                                    {/* Suffix  */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="suffix-id"
                                            size="small"
                                            label="Suffix"
                                            placeholder="e.g. JR, III, IV, V, etc."
                                            fullWidth
                                            value={suffix}
                                            onChange={(event, newValue) => {
                                                setSuffix(event.target.value);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    suffix: null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={!!formErrors.suffix}
                                            helperText={formErrors.suffix}
                                        />
                                    </Grid>
                                    {/* Date of Birth */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                        >
                                            <DateRange
                                                label={
                                                    <span>
                                                        Birthdate
                                                        <span
                                                            style={{
                                                                color: "red",
                                                            }}
                                                        >
                                                            *
                                                        </span>
                                                    </span>
                                                }
                                                allDay="yes"
                                                dateNeeded={birthDate}
                                                setDateNeeded={setBirthDate}
                                                error={formErrors}
                                                errorKey="birthdate"
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    {/* Gender*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <Autocomplete
                                            id="gender-select"
                                            size="small"
                                            value={gender}
                                            onChange={(event, newValue) => {
                                                setGender(newValue);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    gender: null,
                                                }));
                                            }}
                                            options={genderSelection}
                                            getOptionLabel={(option) =>
                                                option.label
                                            }
                                            renderOption={(
                                                props,
                                                option,
                                                { index }
                                            ) => (
                                                <Box
                                                    style={{ fontSize: 14 }}
                                                    {...props}
                                                    id={`option-${index}`}
                                                >
                                                    {option.label}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    error={!!formErrors.gender}
                                                    helperText={
                                                        formErrors.gender
                                                    }
                                                    {...params}
                                                    label={
                                                        <span>
                                                            Sex
                                                            <span
                                                                style={{
                                                                    color: "red",
                                                                }}
                                                            >
                                                                *
                                                            </span>
                                                        </span>
                                                    }
                                                    placeholder="Select an option"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        style: { fontSize: 14 },
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-input":
                                                            {
                                                                backgroundColor:
                                                                    "white !important",
                                                            },
                                                    }}
                                                />
                                            )}
                                            isOptionEqualToValue={(
                                                option,
                                                value
                                            ) => option.label === value.label}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* 4th row :  Additional row:  Nationality, Marital status  */}
                            <Grid item>
                                <Grid
                                    container
                                    direction="row"
                                    spacing={3}
                                    // sx={{
                                    //     maxHeight: {
                                    //         xs: "none",
                                    //         sm: "61.03px",
                                    //         md: "61.03px",
                                    //     },
                                    // }}
                                >
                                    {/* Nationality*/}
                                    {/* <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="nationality-id"
                                            size="small"
                                            label={
                                                <span>
                                                    Nationality
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            fullWidth
                                            value={nationality}
                                            onChange={(event, newValue) => {
                                                setNationality(
                                                    event.target.value
                                                );
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    nationality: null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={!!formErrors.nationality}
                                            helperText={formErrors.nationality}
                                        />
                                    </Grid> */}
                                        <Grid item xs={12} md={12} lg={4}>
                                            <Autocomplete
                                                id="nationality-select"
                                                size="small"
                                                value={nationality}
                                                onChange={(event, newValue) => {
                                                    setNationality(newValue);
                                                    setFormError((prevError) => ({
                                                        ...prevError,
                                                        nationality: null,
                                                    }));
                                                }}
                                                options={nationalityOptions}
                                                getOptionLabel={(option) =>
                                                    option.options || ""
                                                }
                                                renderOption={(
                                                    props,
                                                    option,
                                                    { index }
                                                ) => (
                                                    <Box
                                                        style={{ fontSize: 14 }}
                                                        {...props}
                                                        id={`option-${index}`}
                                                    >
                                                        {option.options}
                                                    </Box>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        error={!!formErrors.nationality}
                                                        helperText={
                                                            formErrors.nationality
                                                        }
                                                        {...params}
                                                        label={
                                                            <span>
                                                                Nationality
                                                                <span
                                                                    style={{
                                                                        color: "red",
                                                                    }}
                                                                >
                                                                    *
                                                                </span>
                                                            </span>
                                                        }
                                                        placeholder="Select an option"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            style: { fontSize: 14 },
                                                        }}
                                                        sx={{
                                                            "& .MuiOutlinedInput-input":
                                                                {
                                                                    backgroundColor:
                                                                        "white !important",
                                                                },
                                                        }}
                                                    />
                                                )}
                                                isOptionEqualToValue={(
                                                    option,
                                                    value
                                                ) => option.id === value.id}
                                            />
                                    </Grid>
                                    {/* Marital*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <Autocomplete
                                            id="marital-select"
                                            size="small"
                                            value={maritalStatus}
                                            onChange={(event, newValue) => {
                                                setMaritalStatus(newValue);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    maritalstatus: null,
                                                }));
                                            }}
                                            options={maritalSelection}
                                            getOptionLabel={(option) =>
                                                option.label
                                            }
                                            renderOption={(
                                                props,
                                                option,
                                                { index }
                                            ) => (
                                                <Box
                                                    style={{ fontSize: 14 }}
                                                    {...props}
                                                    id={`option-${index}`}
                                                >
                                                    {option.label}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={
                                                        !!formErrors.maritalstatus
                                                    }
                                                    helperText={
                                                        formErrors.maritalstatus
                                                    }
                                                    label={
                                                        <span>
                                                            Marital Status
                                                            <span
                                                                style={{
                                                                    color: "red",
                                                                }}
                                                            >
                                                                *
                                                            </span>
                                                        </span>
                                                    }
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        style: { fontSize: 14 },
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-input":
                                                            {
                                                                backgroundColor:
                                                                    "white !important",
                                                            },
                                                    }}
                                                />
                                            )}
                                            isOptionEqualToValue={(
                                                option,
                                                value
                                            ) => option.label === value.label}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        lg={4}
                                        sx={{
                                            display: { xs: "none", md: "flex" },
                                        }}
                                    ></Grid>
                                </Grid>
                            </Grid>
                            {/* 5th row : Address line */}
                            <Grid item>
                                <Grid container direction="row" spacing={3}>
                                    {/* Province*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <Autocomplete
                                            id="province-select"
                                            size="small"
                                            value={province}
                                            onChange={(event, newValue) => {
                                                setProvince(newValue);
                                                console.log(province);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    province: null,
                                                }));
                                            }}
                                            options={provinceOptions}
                                            getOptionLabel={(option) =>
                                                option.description
                                            }
                                            renderOption={(
                                                props,
                                                option,
                                                { index }
                                            ) => (
                                                <Box
                                                    style={{ fontSize: 14 }}
                                                    {...props}
                                                    id={`option-${index}`}
                                                >
                                                    {option.description}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={
                                                        !!formErrors.province
                                                    }
                                                    helperText={
                                                        formErrors.province
                                                    }
                                                    label={
                                                        <span>
                                                            Province
                                                            <span
                                                                style={{
                                                                    color: "red",
                                                                }}
                                                            >
                                                                *
                                                            </span>
                                                        </span>
                                                    }
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        style: { fontSize: 14 },
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {province_loading ? (
                                                                    <CircularProgress
                                                                        color="inherit"
                                                                        size={
                                                                            20
                                                                        }
                                                                    />
                                                                ) : null}
                                                                {
                                                                    params
                                                                        .inputProps
                                                                        .endAdornment
                                                                }
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-input":
                                                            {
                                                                backgroundColor:
                                                                    "white !important",
                                                            },
                                                    }}
                                                />
                                            )}
                                            isOptionEqualToValue={(
                                                option,
                                                value
                                            ) =>
                                                option.description ===
                                                value.description
                                            }
                                        />
                                    </Grid>
                                    {/* City*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <Autocomplete
                                            id="city-select"
                                            size="small"
                                            value={city}
                                            onChange={(event, newValue) => {
                                                setCity(newValue);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    city: null,
                                                }));
                                            }}
                                            options={cityOptions}
                                            getOptionLabel={(option) =>
                                                option.description
                                            }
                                            renderOption={(
                                                props,
                                                option,
                                                { index }
                                            ) => (
                                                <Box
                                                    style={{ fontSize: 14 }}
                                                    {...props}
                                                    id={`option-${index}`}
                                                >
                                                    {option.description}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={!!formErrors.city}
                                                    helperText={formErrors.city}
                                                    label={
                                                        <span>
                                                            City
                                                            <span
                                                                style={{
                                                                    color: "red",
                                                                }}
                                                            >
                                                                *
                                                            </span>
                                                        </span>
                                                    }
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        style: { fontSize: 14 },
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {city_loading ? (
                                                                    <CircularProgress
                                                                        color="inherit"
                                                                        size={
                                                                            20
                                                                        }
                                                                    />
                                                                ) : null}
                                                                {
                                                                    params
                                                                        .InputProps
                                                                        .endAdornment
                                                                }
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-input":
                                                            {
                                                                backgroundColor:
                                                                    "white !important",
                                                            },
                                                    }}
                                                />
                                            )}
                                            isOptionEqualToValue={(
                                                option,
                                                value
                                            ) =>
                                                option.description ===
                                                value.description
                                            }
                                        />
                                    </Grid>
                                    {/* Street*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="street-id"
                                            size="small"
                                            label={
                                                <span>
                                                    Street
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            fullWidth
                                            value={street}
                                            onChange={(event, newValue) => {
                                                setStreet(event.target.value);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    street: null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={!!formErrors.street}
                                            helperText={formErrors.street}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* 6th row : continuation of adress */}
                            <Grid item>
                                <Grid container direction="row" spacing={3}>
                                    {/* Barangay*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <Autocomplete
                                            id="barnagay-select"
                                            size="small"
                                            value={barangay}
                                            onChange={(event, newValue) => {
                                                setBarangay(newValue);
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    barangay: null,
                                                }));
                                            }}
                                            options={barangayOptions}
                                            getOptionLabel={(option) =>
                                                option.description
                                            }
                                            renderOption={(
                                                props,
                                                option,
                                                { index }
                                            ) => (
                                                <Box
                                                    style={{ fontSize: 14 }}
                                                    {...props}
                                                    id={`option-${index}`}
                                                >
                                                    {option.description}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={
                                                        !!formErrors.barangay
                                                    }
                                                    helperText={
                                                        formErrors.barangay
                                                    }
                                                    label={
                                                        <span>
                                                            Barangay
                                                            <span
                                                                style={{
                                                                    color: "red",
                                                                }}
                                                            >
                                                                *
                                                            </span>
                                                        </span>
                                                    }
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        style: { fontSize: 14 },
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {barangay_loading ? (
                                                                    <CircularProgress
                                                                        color="inherit"
                                                                        size={
                                                                            20
                                                                        }
                                                                    />
                                                                ) : null}
                                                                {
                                                                    params
                                                                        .inputProps
                                                                        .endAdornment
                                                                }
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-input":
                                                        {
                                                            backgroundColor:
                                                                "white !important",
                                                        },
                                                    }}
                                                />
                                            )}
                                            isOptionEqualToValue={(
                                                option,
                                                value
                                            ) =>
                                                option.description ===
                                                value.description
                                            }
                                        />
                                    </Grid>
                                    {/* Zip Code*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="zip-code-id"
                                            size="small"
                                            label={"Zip Code"}
                                            fullWidth
                                            value={zipCode}
                                            onChange={(event, newValue) => {
                                                setZipCode(event.target.value);
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                {
                                                    WebkitTextFillColor:
                                                        "#000000",
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item sx={{ paddingTop: "15px !important" }}>
                                <Typography variant="h5">
                                    {" "}
                                    Contact Info
                                </Typography>
                            </Grid>
                            <Divider variant="middle" />
                            {/* 7th row :  Email  */}
                            <Grid item sx={{ paddingTop: "10px !important" }}>
                                <Grid container direction="row" spacing={3}>
                                    {/* Email Address*/}
                                    <Grid item xs={12} md={12} lg={6}>
                                        <TextField
                                            id="email-id"
                                            size="small"
                                            label={
                                                <span>
                                                    Email Address
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            fullWidth
                                            value={emailAddress}
                                            onChange={(event, newValue) => {
                                                setEmailAddress(
                                                    event.target.value
                                                );
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    emailAddress: null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={!!formErrors.emailAddress}
                                            helperText={formErrors.emailAddress}
                                        />
                                    </Grid>
                                    {/* Email Address Confirmation*/}
                                    <Grid item xs={12} md={12} lg={6}>
                                        <TextField
                                            id="email-confirmation-id"
                                            size="small"
                                            label={
                                                <span>
                                                    Email Address Confirmation
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            fullWidth
                                            value={emailAddressConfirmation}
                                            onChange={(event, newValue) => {
                                                setEmailAddressConfirmation(
                                                    event.target.value
                                                );
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    emailAddressConfirmation:
                                                        null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={
                                                !!formErrors.emailAddressConfirmation
                                            }
                                            helperText={
                                                formErrors.emailAddressConfirmation
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* 8th row : Contact Info */}
                            <Grid item>
                                <Grid container direction="row" spacing={3}>
                                    {/* Contact Number*/}
                                    <Grid item xs={12} md={12} lg={6}>
                                        <TextField
                                            id="contact-number-id"
                                            size="small"
                                            label={
                                                <span>
                                                    Contact Number
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            fullWidth
                                            value={contactNumber}
                                            onChange={(event, newValue) => {
                                                setContactNumber(
                                                    event.target.value
                                                );
                                                setFormError((prevError) => ({
                                                    ...prevError,
                                                    contactNumber: null,
                                                }));
                                            }}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                            error={!!formErrors.contactNumber}
                                            helperText={
                                                formErrors.contactNumber
                                            }
                                        />
                                    </Grid>
                                    {/* White space*/}
                                    <Grid item md={12} lg={6}></Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                );
            case 2:
                return (
                    <Box>
                        <Grid container direction="column" spacing={3.5}>
                            {/* 1st row : Crew Information & Position & Date of Repat  */}
                            <Grid item sx={{ paddingTop: "15px !important" }}>
                                <Typography variant="h5"> Crew Info</Typography>
                            </Grid>
                            <Divider variant="middle" />
                            <Grid item sx={{ paddingTop: "10px !important" }}>
                                <Grid
                                    container
                                    direction="row"
                                    spacing={1}
                                    sx={{ paddingTop: "0" }}
                                >
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="crew-id"
                                            size="small"
                                            label="Crew Member ID"
                                            fullWidth
                                            value={crewId}
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            disabled
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* Position*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="position-id"
                                            size="small"
                                            label={
                                                <span>
                                                    Position
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>
                                                </span>
                                            }
                                            fullWidth
                                            disabled
                                            value={position}
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            sx={{
                                                boxShadow: 1,

                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* Date of Repat */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="last-name-id"
                                            size="small"
                                            label="Date of Repatriation"
                                            fullWidth
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            disabled
                                            value={dayjs(repatDate).format(
                                                "MM/DD/YYYY"
                                            )}
                                            sx={{
                                                boxShadow: 1,

                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item sx={{ paddingTop: "15px !important" }}>
                                <Typography variant="h5">
                                    {" "}
                                    Personal Info
                                </Typography>
                            </Grid>
                            <Divider variant="middle" />
                            {/* 2nd row : Full Name*/}
                            <Grid item sx={{ paddingTop: "10px !important" }}>
                                <Grid
                                    container
                                    direction="row"
                                    spacing={3}
                                    sx={{ paddingTop: "0" }}
                                >
                                    {/* First Name */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="first-name-id"
                                            size="small"
                                            label="First Name"
                                            fullWidth
                                            value={firstName}
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            disabled
                                            sx={{
                                                boxShadow: 1,

                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* Middle Name */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="middle-name-id"
                                            size="small"
                                            label="Middle Name"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            value={middleName}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",

                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* Last Name */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="last-name-id"
                                            size="small"
                                            label="Last Name"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            inputProps={{
                                                style: { userSelect: "none" },
                                            }}
                                            value={lastName}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",

                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* 3rd row : Suffix, BirthDate, Gender */}
                            <Grid item>
                                <Grid container direction="row" spacing={3}>
                                    {/* Suffix  */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="suffix-id"
                                            size="small"
                                            label="Suffix"
                                            placeholder="e.g. JR, III, IV, V, etc."
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            value={suffix}
                                            sx={{
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* Date of Birth */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="birthdate-id"
                                            size="small"
                                            label="Birthdate"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            value={dayjs(birthDate).format(
                                                "MM/DD/YYYY"
                                            )}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* Gender*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="gender-id"
                                            size="small"
                                            label="Gender"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            value={gender.label}
                                            sx={{
                                                userSelect: "none",
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* 4th row :  Additional row: Nationality, Marital status  */}
                            <Grid item>
                                <Grid container direction="row" spacing={3}>
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="nationality-select"
                                            size="small"
                                            label="Nationality"
                                            fullWidth
                                            disabled
                                            value={nationality?.options || ""}
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* Marital Status */}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="marital-status-id"
                                            size="small"
                                            label="Marital Status"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            value={maritalStatus.label}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* White Space*/}
                                    <Grid item md={12} lg={4}></Grid>
                                </Grid>
                            </Grid>
                            {/* 5th row : Address line */}
                            <Grid item>
                                <Grid container direction="row" spacing={3}>
                                    {/* Province*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="province-id"
                                            size="small"
                                            label="Province"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            value={province.description}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* City*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="city-id"
                                            size="small"
                                            label="City"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            value={city.description}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* Street*/}
                                    <Grid item xs={12} md={12} lg={4}>
                                        <TextField
                                            id="street-id"
                                            size="small"
                                            label="Street"
                                            fullWidth
                                            disabled
                                            value={street}
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item sx={{ paddingTop: "15px !important" }}>
                                <Typography variant="h5">
                                    {" "}
                                    Contact Info
                                </Typography>
                            </Grid>
                            <Divider variant="middle" />
                            {/* 7th row :  Email  */}
                            <Grid item sx={{ paddingTop: "10px !important" }}>
                                <Grid
                                    container
                                    direction="row"
                                    spacing={3}
                                    sx={{ paddingTop: "0" }}
                                >
                                    {/* Email Address*/}
                                    <Grid item xs={12} md={12} lg={6}>
                                        <TextField
                                            id="email-id"
                                            size="small"
                                            label="Email Address"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            value={emailAddress}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* Email Address Confirmation*/}
                                    <Grid item xs={12} md={12} lg={6}>
                                        <TextField
                                            id="email-confirmation-id"
                                            size="small"
                                            label="Confirm Email Address"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            value={emailAddressConfirmation}
                                            sx={{
                                                boxShadow: 1,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* 8th row : Contact Info */}
                            <Grid item>
                                <Grid container direction="row" spacing={3}>
                                    {/* Contact Number*/}
                                    <Grid item xs={12} md={12} lg={6}>
                                        <TextField
                                            id="contact-number-id"
                                            size="small"
                                            label="Contact Number"
                                            fullWidth
                                            disabled
                                            value={contactNumber}
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    pointerEvents: "none",
                                                },
                                            }}
                                            sx={{
                                                boxShadow: 0,
                                                height: "37.13px",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    height: "100%",
                                                    boxSizing: "border-box",

                                                    backgroundColor:
                                                        "white !important",
                                                },
                                                "& .MuiInputBase-input.Mui-disabled":
                                                    {
                                                        WebkitTextFillColor:
                                                            "#000000",
                                                    },
                                            }}
                                        />
                                    </Grid>
                                    {/* White space*/}
                                    <Grid item md={12} lg={6}></Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Divider variant="middle" />
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        pt: 2,
                                    }}
                                >
                                    <ReCaptchaComponent
                                        onVerified={handleVerification}
                                        errorMessage={errorMessage}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                );
            case 3:
                return (
                    <>
                        <Typography sx={{ fontSize: 14, mb: 2 }}>
                            To continue, please click <strong>Send OTP</strong>{" "}
                            to send the code to <strong>{emailAddress}</strong>.
                            If you did not receive your OTP via email within{" "}
                            <strong>2 minutes</strong> or if your OTP has
                            expired, generate another OTP request.
                        </Typography>
                        <Grid
                            container
                            spacing={2}
                            sx={{ justifyContent: "space-between" }}
                        >
                            <Grid item xs>
                                <Grid container direction="column">
                                    <Grid item sx={{ maxHeight: "40px" }}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            label="Enter your OTP"
                                            value={otp}
                                            onChange={(event) => {
                                                setOtp(event.target.value);
                                                setError("");
                                                console.log(event.target.value);
                                            }}
                                            size="small"
                                            sx={{
                                                mb: 2,
                                            }}
                                            error={Boolean(error)}
                                            // helperText={error || " "}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        sx={{
                                            paddingTop: "0px !important",
                                        }}
                                    >
                                        {error && (
                                            <small
                                                style={{
                                                    color: "#ca3935",
                                                    fontSize: "13px",
                                                }}
                                            >
                                                {" "}
                                                {error}
                                            </small>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs="auto">
                                <Grid container direction="column">
                                    <Grid item>
                                        <Button
                                            id="send_otp_btn"
                                            variant="contained"
                                            onClick={handleBtnClick}
                                            disabled={send_otp_btn_disabled}
                                            sx={{
                                                minWidth: "100px",
                                                minHeight: "40px",
                                            }}
                                        >
                                            {send_otp_btn_loading ? (
                                                <CircularProgress
                                                    color="inherit"
                                                    size={20}
                                                />
                                            ) : (
                                                "Send OTP"
                                            )}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        {timerVisible && (
                                            <CountdownTimer
                                                endDate={endDate}
                                                onEndCallback={handleTimerEnd}
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                );
            default:
                return null;
        }
    };
    console.log(emailAddressConfirmation);
    console.log(contactNumber);
    console.log("birthdate", birthDate);
    console.log("gender", gender);
    console.log("Marital", maritalStatus);
    console.log("Province", province);
    console.log("city", city);
    console.log("street", street);
    console.log("barangay", barangay);
    console.log("zipcode", zipCode);
    console.log("otp", otp);
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
            }}
        >
            <Paper
                elevation={3}
                sx={{ padding: 4, width: "100%", maxWidth: 1300 }}
            >
                <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
                    <img
                        src="/images/sh/Logo-latest.png"
                        style={{
                            maxWidth: "60%",
                        }}
                    />
                </Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography variant="h4" gutterBottom>
                        Patient Registration
                    </Typography>
                </Box>

                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Box sx={{ mt: 2, mb: 2 }}>
                    {activeStep === steps.length ? (
                        <>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    paddingTop: "10px",
                                }}
                            >
                                <Typography
                                    variant="body"
                                    style={{
                                        fontSize: "1.3rem",
                                        textAlign: "justify",
                                    }}
                                >
                                    Thank you for signing up! Your request has
                                    been received, and you should receive a
                                    confirmation email within 24–48 hours. If
                                    the email does not appear in your inbox,
                                    please check your Spam or Junk folder.
                                    <br />
                                    <br />
                                    You will be redirected to the homepage
                                    shortly.
                                </Typography>
                            </Box>
                        </>
                    ) : (
                        <div>
                            {renderStepContent(activeStep)}
                            <Box
                                sx={{
                                    mt: 4,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    {activeStep !== 0 && (
                                        <Button
                                            id="back-button"
                                            variant="contained"
                                            onClick={handleBack}
                                            sx={{ mr: 1 }}
                                        >
                                            Back
                                        </Button>
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <Button
                                        id="next-button"
                                        variant="contained"
                                        onClick={handleNext}
                                        disabled={btn_loading}
                                    >
                                        {btn_loading ? (
                                            <CircularProgress
                                                size={24}
                                                color="inherit"
                                            />
                                        ) : activeStep === steps.length - 1 ? (
                                            "Verify"
                                        ) : (
                                            "Next"
                                        )}
                                    </Button>
                                </Box>
                            </Box>
                        </div>
                    )}
                </Box>
            </Paper>

            <PromptDialog
                title="Error"
                show={showErrorModal}
                variant="alert"
                message="This Patient already exists in the system."
                onDialogClose={() => {
                    setErrorModal(false);
                }}
            />
        </Box>
    );
}
if (document.getElementById("patientRegister")) {
    ReactDOM.render(<Register />, document.getElementById("patientRegister"));
}
